import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(url: string, isMobile: boolean) {
  if (!url) return "";
  if (url.includes("unsplash.com")) {
    const targetWidth = isMobile ? "1080" : "1920";
    let newUrl = url;
    if (newUrl.includes("w=")) {
      newUrl = newUrl.replace(/w=\d+/, `w=${targetWidth}`);
    } else {
      newUrl = `${newUrl}&w=${targetWidth}`;
    }
    if (newUrl.includes("q=")) {
      newUrl = newUrl.replace(/q=\d+/, "q=85");
    } else {
      newUrl = `${newUrl}&q=85`;
    }
    if (!newUrl.includes("auto=")) {
      newUrl = `${newUrl}&auto=format,compress`;
    } else {
      newUrl = newUrl.replace(/auto=[a-zA-Z0-9,]+/, "auto=format,compress");
    }
    return newUrl;
  }
  return url;
}

